import * as angular from 'angular';

import { ComponentDefinition, ICharm } from '../../models';

class CharmController implements angular.IComponentController {
    isCharmPopulated: boolean;
    isDanger: boolean;
    isLoading: boolean;
    isWarning: boolean;
    model: ICharm;
    text: string;
    values: Object;
    tooltip: string;

    static $inject = [];
    
    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['model']?.currentValue) {
            this.refresh(changesObj['model'].currentValue);
        }
        if (changesObj['isCharmPopulated']?.currentValue && this.model) {
            this.refresh(this.model);
        }
    }

    private refresh(model: ICharm): void {
        this.text = model.text;
        this.values = model.values;
        if (model.callback) {
            this.isLoading = true;
            model
                .callback()
                .then(data => {
                    this.isDanger = data.isDanger;
                    this.isWarning = data.isWarning;
                    this.text = data.text || model.text;
                    this.values = data.values || model.values;
                    this.tooltip = data.tooltip || model.tooltip;
                })
                .finally(() => this.isLoading = false);
        }
    }
}

export const wtCharm: ComponentDefinition = {
    componentId: 'wtCharm',
    controller: CharmController,
    template: require('./charm.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '<?',
        isCharmPopulated: '<?'
    }
};